
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/er-solution",
      function () {
        return require("private-next-pages/er-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/er-solution"])
      });
    }
  